// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Caml_array from "../../../../../node_modules/rescript/lib/es6/caml_array.js";

function calculateSliderThumbPosition(current_score, min_score, max_score) {
  var clamped_value = Math.min(Math.max(min_score, current_score), max_score);
  return String((clamped_value - min_score) / (max_score - min_score) * 100);
}

function getSliderBoxPosition(current_score, min_score, max_score) {
  var thumb_position = calculateSliderThumbPosition(current_score, min_score, max_score);
  switch (thumb_position) {
    case "0" :
        return "0%";
    case "100" :
        return "calc(100% - 49px)";
    default:
      return "calc(" + thumb_position + "% - 24.5px)";
  }
}

function getSliderTrackBackgroundColor(threshold_values, slider_colors) {
  return "linear-gradient(90deg, " + Caml_array.get(slider_colors, 0) + " " + Caml_array.get(threshold_values, 0) + ", " + Caml_array.get(slider_colors, 1) + " " + Caml_array.get(threshold_values, 1) + ", " + Caml_array.get(slider_colors, 2) + " 100%)";
}

export {
  calculateSliderThumbPosition ,
  getSliderBoxPosition ,
  getSliderTrackBackgroundColor ,
  
}
/* No side effect */
